import React, {forwardRef} from "react"
import classes from './FieldColorSelect5.module.css'
import { Form } from "react-bootstrap"
import Button from 'react-bootstrap/Button'

/**
 * FieldColorSelect component.
 * @param {object} props 
 * @param {*} ref
 * 
 * 4 button control with values from 1 through 4.
 */
const TwoFieldOptions = (props, ref) => {

    return <div ref={ref} className={classes.questionWrapper}>
    
        <h1>{ props.number }.</h1>
        <h1 className="mb-5">{ props.title }</h1>

        <Form.Label>

            <div className={classes.optionsContainer}>

                <Button
                    className={ [classes.optionButton, classes.btnExcellent].join( ' ' ) }
                        variant={ 'si' }
                        onClick={ (e) => {
                            props.setValue("Si")
                            props.onClick(e)
                        }
                    }
                >
                    Si 👍
                </Button>

              

                <Button
                    className={ [classes.optionButton, classes.btnRed].join(' ') }
                    variant={ 'no' }
                    onClick={ (e) => {
                            props.setValue("No")
                            props.onClick(e)
                        }
                    }
                >
                    No 😕
                </Button>

            </div>

        </Form.Label>

    </div>

}

export default forwardRef(TwoFieldOptions)